/**
 * Shared validation schemas for service-layer input validation.
 * Uses Zod for runtime type checking before database operations.
 */
import { z } from "zod";

const MAX_TEXT = 200;
const MAX_LONG_TEXT = 2000;

export const createEmployeeSchema = z.object({
  firstName: z.string().trim().min(1, "Le prénom est requis").max(100),
  lastName: z.string().trim().min(1, "Le nom est requis").max(100),
  email: z.string().trim().email("Adresse courriel invalide").max(255),
  roleTitle: z.string().max(MAX_TEXT).optional(),
  departmentId: z.string().uuid().nullable().optional(),
  managerId: z.string().uuid().nullable().optional(),
  hireDate: z.string().max(20).nullable().optional(),
  phoneNumber: z.string().max(30).nullable().optional(),
  workLocation: z.string().max(MAX_TEXT).nullable().optional(),
  organizationId: z.string().regex(
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
    "ID d'organisation invalide",
  ),
});

export const updateEmployeeSchema = z.object({
  mandate: z.string().max(MAX_LONG_TEXT).nullable().optional(),
  key_tasks: z.array(z.string().max(MAX_TEXT)).max(20).optional(),
  contact_subject: z.string().max(MAX_TEXT).nullable().optional(),
  work_location: z.string().max(MAX_TEXT).nullable().optional(),
  phone_number: z.string().max(30).nullable().optional(),
  specific_location: z.string().max(MAX_TEXT).nullable().optional(),
  preferred_language: z.string().max(50).nullable().optional(),
  birthday: z.string().max(20).nullable().optional(),
  role_title: z.string().max(MAX_TEXT).nullable().optional(),
  desired_position_title: z.string().max(MAX_TEXT).nullable().optional(),
});

export const magicLinkRequestSchema = z.object({
  email: z
    .string()
    .trim()
    .email("Adresse courriel invalide")
    .max(255)
    .refine((e) => e.endsWith("@amelio.co"), "Seules les adresses @amelio.co sont autorisées."),
  redirectTo: z.string().url().max(500),
});

export const searchQuerySchema = z
  .string()
  .trim()
  .min(2, "Requête trop courte")
  .max(100, "Requête trop longue");

export const handoutCustomSectionSchema = z.object({
  id: z.string().min(1).max(150),
  text: z.string().max(20_000),
  editing: z.boolean(),
  presetKey: z.string().max(100).optional(),
  language: z.string().max(10).optional(),
});

const handoutCompetencyOverrideSchema = z.object({
  id: z.union([z.number(), z.string()]),
  name: z.string().max(500),
  description: z.string().max(2000),
  level: z.string().max(100).optional(),
});

export const handoutDataSchema = z.object({
  customSections: z.record(z.string(), handoutCustomSectionSchema),
  masteredCompetencies: z.array(handoutCompetencyOverrideSchema).max(50).optional(),
  growingCompetencies: z.array(handoutCompetencyOverrideSchema).max(50).optional(),
});
